import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";

import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { useAuth } from "@/contexts/AuthContext";
import { listMergedMyCertificateRequests } from "@/services/userAccountantRequestsService";

export function RootRedirect(): JSX.Element {
  const { isLoading, user } = useAuth();

  const isB2CConsumerWithoutWorkspace =
    user != null &&
    user.tenantId == null &&
    user.platformRole == null &&
    user.isNotary !== true &&
    user.isAccountant !== true;

  const { data: mergedRequests, isLoading: requestsLoading, isError } = useQuery({
    queryKey: ["me", "certificate-requests"],
    queryFn: listMergedMyCertificateRequests,
    enabled: !isLoading && isB2CConsumerWithoutWorkspace,
  });

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  if (isB2CConsumerWithoutWorkspace && requestsLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  if (isB2CConsumerWithoutWorkspace) {
    if (isError) {
      return <Navigate to="/requests" replace />;
    }
    const hasExistingRequests = (mergedRequests?.length ?? 0) > 0;
    return (
      <Navigate to={hasExistingRequests ? "/requests" : "/requests/new"} replace />
    );
  }

  return <Navigate to="/requests" replace />;
}
